<template>
  <b-tab>
    <template #title>
      <span class="d-none d-sm-inline">Distance Bonus</span>
    </template>
    <b-container>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <b-button
          variant="success"
          @click="validateForm"
        >
          Save Distance Bonus
        </b-button>
        <b-button
          variant="primary"
          @click="addNewForm"
        >
          <span>Add new distance-bonus</span>

        </b-button>
      </div>

      <validation-observer
        v-for="(el, index) in bonusArr"
        :key="el.localId"
        :ref="`bonusRef-${el.localId}`"
      >
        <b-form>
          <b-row
            class="pb-5 bonus_form_style"
          >
            <b-col
              md="12"
              class="d-flex justify-content-end"
            >
              <b-button
                variant="flat"
                @click="deleteForm(index)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="25"
                  style="color: #CE224D"
                />
              </b-button>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="from"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From State"
                  :label-for="`from${el.localId}`"
                >
                  <v-select
                    :id="`from${el.localId}`"
                    v-model="el.from_state"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="to"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To State"
                  :label-for="`to${el.localId}`"
                >
                  <v-select
                    :id="`to${el.localId}`"
                    v-model="el.to_state"
                    :options="tripStates"
                    :reduce="state => state.key"
                    :clearable="false"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="From Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="From Distance"
                  :label-for="`from-distance-${el.localId}`"
                >
                  <b-form-input
                    :id="`from-distance-${el.localId}`"
                    v-model="el.from_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="To Distance"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="To Distance"
                  :label-for="`To-distance-${el.localId}`"
                >
                  <b-form-input
                    :id="`To-distance-${el.localId}`"
                    v-model="el.to_distance"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="Amount"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Amount"
                  :label-for="`amount-${el.localId}`"
                >
                  <b-form-input
                    :id="`amount-${el.localId}`"
                    v-model="el.amount"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-container>

  </b-tab>
</template>

<script>
import {
  BTab, BContainer, BRow, BCol, BFormInput, BButton, BFormGroup, BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { tripStates } from '../../hooks/useStaticOptions'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import useValidateDynamicForm from '../../hooks/use-validate-dynamic-forms'

export default {
  components: {
    BTab,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BForm,
  },
  props: {
    bonusArray: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const bonusArr = ref([...props.bonusArray.map(el => ({ ...el, localId: Math.random().toString() }))])

    const addNewForm = () => {
      const tempBonus = {
        localId: Math.random().toString(),
        from_state: 'ACCEPTED',
        to_state: 'ARRIVED',
        from_distance: null,
        to_distance: null,
        amount: null,
      }
      bonusArr.value.unshift(tempBonus)
    }
    const deleteForm = index => {
      bonusArr.value.splice(index, 1)
    }

    const validateForm = async () => {
      const isValid = await useValidateDynamicForm(ctx)
      if (isValid) {
        ctx.emit('distance-bonus-set', bonusArr.value)
        ctx.emit('applied', bonusArr.value)
        successNotification('Saved...')
      } else {
        errorNotification('Fill out the required fields')
      }
    }

    return {
      required,
      tripStates,
      validateForm,
      addNewForm,
      deleteForm,
      bonusArr,
    }
  },
}
</script>

<style scoped>
.bonus_form_style{
    border: 3px solid lightgray;
    padding: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
}
</style>
